module.exports = __webpack_public_path__ + "img/Layer_10.bcc09a71.png";